module.exports = __webpack_public_path__ + "1570d87a724f49070ec60f254b9e8374.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/wings/middown-13.png
// module id = 2521
// module chunks = 0